module.exports = __webpack_public_path__ + "static/media/success_message.995a297b.svg";